exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ProviderPicker-search-30FSK{overflow:hidden;padding:10px;border-bottom:1px solid #dadada}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb{overflow:hidden}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input{height:24px;width:100%;border:0;background:transparent;font-size:14px;font-weight:400;line-height:14px;text-transform:uppercase;text-align:center;color:#b0bec5}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input:-ms-input-placeholder{color:#b0bec5}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input::placeholder{color:#b0bec5}.ProviderPicker-search-30FSK .ProviderPicker-container-1yrRb input:focus{outline:0}.ProviderPicker-search-30FSK i{display:none}@media (min-width:768px){.ProviderPicker-search-30FSK i{display:block;float:right}}.ProviderPicker-data-T8Ls1{margin:0;padding:0;list-style-type:none}.ProviderPicker-data-T8Ls1>li{margin:5px 0}.ProviderPicker-data-T8Ls1>li label{font-weight:400;color:#546d79}", ""]);

// exports
exports.locals = {
	"search": "ProviderPicker-search-30FSK",
	"container": "ProviderPicker-container-1yrRb",
	"data": "ProviderPicker-data-T8Ls1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/provider/components/ProviderPicker.less
// module id = 1721
// module chunks = 0